<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">账号：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入账号" style="width:400px;" v-model="subData.wechatNum"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">手机号：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入手机号" style="width:400px;" maxnlength="11" v-model="subData.mobile"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">昵称：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入昵称" style="width:400px;" v-model="subData.nickname"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">真实姓名：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入真实姓名" style="width:400px;" v-model="subData.realName"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">性别：</el-text>
			<el-col :span="213">
				<el-radio v-model="subData.sex" label="1">男</el-radio>
				<el-radio v-model="subData.sex" label="0">女</el-radio>
				<el-radio v-model="subData.sex" label="2">保密</el-radio>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">用户头像：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入用户头像" style="width:400px;" v-model="subData.face"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">生日：</el-text>
			<el-col :span="4">
				<el-date-picker v-model="subData.birthday" type="date" placeholder="选择日期"></el-date-picker>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">省份：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入省份" style="width:400px;" v-model="subData.province"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">城市：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入城市" style="width:400px;" v-model="subData.city"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">区县：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入区县" style="width:400px;" v-model="subData.district"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">我的一句话签名：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入我的一句话签名" style="width:400px;" v-model="subData.signature"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">关联圈子：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入关联圈子" style="width:400px;" v-model="subData.categoryId"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">会员等级：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入会员等级" style="width:400px;" v-model="subData.vipLevelId"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">会员到期时间：</el-text>
			<el-col :span="4">
				<el-date-picker v-model="subData.vipOvertime" type="datetime" placeholder="选择日期"></el-date-picker>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">学校：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入学校" style="width:400px;" v-model="subData.schoolId"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">推荐人：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入推荐人" style="width:400px;" v-model="subData.recommendUserId"></el-input>
			</el-col>
		</el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>
export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
		wechatNum : '',
		wechatNumImg : '',
		mobile : '',
		nickname : '',
		realName : '',
		sex : '',
		face : '',
		email : '',
		birthday : '',
		country : '',
		province : '',
		city : '',
		district : '',
		signature : '',
		categoryId : '',
		vipLevelId : '',
		vipOvertime : '',
		schoolId : '',
		coin : '',
		numMeili : '',
		numActive : '',
		recommendUserId : '',

      }
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/Users/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;
      ths.$post('/Users/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/UsersList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>